import * as Sentry from "@sentry/react";

// Temporary: expose Sentry on window so we can poke at it from DevTools
// while debugging. Remove once we've confirmed events flow correctly.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).Sentry = Sentry;

const DSN = process.env.REACT_APP_SENTRY_DSN;
const ENVIRONMENT =
  process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV;

export const initSentry = () => {
  // No DSN configured (typical for local dev) — no-op.
  if (!DSN) return;

  // Defensive: Sentry's applyDefaultOptions reads `WINDOW.SENTRY_RELEASE?.id`.
  // In our CRA 5 setup this throws "reading 'id'" on undefined — strongly
  // suggesting babel-loader transpiled the optional chaining incorrectly.
  // Pre-setting the global with a real object short-circuits the broken
  // transform.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).SENTRY_RELEASE = { id: "borea-client-portal@dev" };

  try {
    Sentry.init({
      dsn: DSN,
      environment: ENVIRONMENT,
      sendDefaultPii: true,
      release: "borea-client-portal",
    });
  } catch (err) {
    // Sentry init can blow up under unusual bundler / DSN conditions.
    // Don't let it take the whole app down with it.
    // eslint-disable-next-line no-console
    console.log(DSN, ENVIRONMENT);
    console.error("Sentry init failed:", err);
  }
};

export const setSentryUser = (linkedContact: string | undefined) => {
  if (!DSN) return;
  if (linkedContact) {
    Sentry.setUser({ id: linkedContact });
  } else {
    Sentry.setUser(null);
  }
};

export const { captureException, startInactiveSpan } = Sentry;
